<ng-container *transloco="let g; read 'home.calculator.map'">
  <div class="w-full">
    <div class="mb-3" *ngIf="!_dataInputDone">
      <psc-google-autocomplete
        [countries]="countries"
        (setAddress)="setAddress($event)"
        [(ngModel)]="addressValue"></psc-google-autocomplete>
    </div>

    <div
      *ngIf="_dataInputDone && staticMapImageUrl; else interactiveMap"
      class="map-shell relative mx-auto h-[260px] w-[260px] rounded-md overflow-hidden border border-gray-200 shadow-inner">
      <img
        [src]="staticMapImageUrl"
        alt="Selected house location"
        width="260"
        height="260"
        class="h-full w-full object-cover"/>
    </div>

    <ng-template #interactiveMap>
      <div
        class="map-shell relative w-full min-h-[260px] h-[min(52vh,520px)] sm:h-[min(56vh,580px)] md:h-[min(60vh,640px)] lg:h-[min(64vh,802px)] xl:h-[822px] rounded-md overflow-hidden border border-gray-200 shadow-inner">
        <google-map
          class="block h-full w-full min-h-[inherit]"
          [height]="googleMapCssSize"
          [width]="googleMapCssSize"
          [center]="center"
          [options]="mapOptions"
          [zoom]="mapZoom"
          (mapInitialized)="mapInitialized($event)">
          <map-marker *ngIf="markerPosition" [position]="markerPosition"></map-marker>
        </google-map>

        <!-- Live guidance: what to do next, plus the area as it is being drawn -->
        <!-- drawingHintKey resolves to: t(home.calculator.map.draw_roof.hint_start, home.calculator.map.draw_roof.hint_more_points, home.calculator.map.draw_roof.hint_close) -->
        <div
          *ngIf="!_dataInputDone && !isPolygonFinished"
          @inOutAnimation
          class="absolute top-2 left-2 right-14 sm:right-auto sm:max-w-[22rem] z-10 rounded-md bg-white/95 shadow-md px-3 py-2 flex items-start gap-2">
          <mat-icon fontIcon="touch_app" class="!text-[18px] flex-shrink-0 {{colorConfig.textColor}}"></mat-icon>
          <div class="min-w-0">
            <p class="text-xs leading-snug text-gray-700">{{ g(drawingHintKey) }}</p>
            <p *ngIf="pointsPlaced" class="text-xs font-semibold mt-0.5 {{colorConfig.textColor}}">
              {{ g('draw_roof.points_count', { count: pointsPlaced }) }}<ng-container *ngIf="drawnAreaM2"> · ≈ {{ drawnAreaM2 | number:'1.0-0' }} m²</ng-container>
            </p>
          </div>
        </div>

        <!-- Drawing actions: anchored bottom-left, equal width, centered icon + label -->
        <div
          *ngIf="!_dataInputDone"
          class="absolute bottom-8 left-2 sm:left-[11px] z-10 flex flex-col gap-2 items-stretch">
          <button
            *ngIf="canFinishDrawing"
            type="button"
            (click)="finishDrawing()"
            class="flex items-center justify-center gap-2 cursor-pointer rounded-md bg-white hover:bg-gray-100 transition-all ease-in-out px-3 py-2 shadow-md text-sm font-semibold {{colorConfig.textColor}}">
            <mat-icon fontIcon="check" class="!text-[18px] {{colorConfig.textColor}}"></mat-icon>
            <span>{{ g('draw_roof.finish') }}</span>
          </button>

          <button
            *ngIf="canUndoLastPoint"
            type="button"
            (click)="undoLastPoint()"
            class="flex items-center justify-center gap-2 cursor-pointer rounded-md bg-white hover:bg-gray-100 transition-all ease-in-out px-3 py-2 shadow-md text-sm font-semibold {{colorConfig.textColor}}">
            <mat-icon fontIcon="undo" class="!text-[18px] {{colorConfig.textColor}}"></mat-icon>
            <span>{{ g('draw_roof.undo') }}</span>
          </button>

          <button
            type="button"
            (click)="resetDrawing()"
            class="flex items-center justify-center gap-2 cursor-pointer rounded-md bg-white hover:bg-gray-100 transition-all ease-in-out px-3 py-2 shadow-md text-sm font-semibold {{colorConfig.textColor}}">
            <mat-icon fontIcon="close" class="!text-[18px] {{colorConfig.textColor}}"></mat-icon>
            <span>{{ g('draw_roof.redraw') }}</span>
          </button>
        </div>

        <!-- Current location button left unchanged (icon is already clear) -->
        <div
          *ngIf="!_dataInputDone"
          class="absolute bottom-[min(28%,180px)] sm:bottom-[200px] right-2 sm:right-[11px] z-10 flex flex-col gap-2 items-end">
          <div
            @inOutAnimation
            (click)="getUserLocation()"
            class="flex cursor-pointer rounded-[2px] bg-white hover:bg-gray-200 transition-all ease-in-out p-2 shadow-sm">
            <mat-icon fontIcon="my_location" class="{{colorConfig.textColor}}"></mat-icon>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>
